import React from 'react';
import { useTranslation } from 'app/i18n';
import { i18nNamespaceMFAContent } from 'modules/2023-q3/components/mfa/mfa';
import { Box, Grid } from '@material-ui/core';
import { Typography, TypographyVariant } from 'components/core';
import { ReactComponent as IconCheckmarkCircleGreen } from 'assets/icons/checkmarks/checkmark-circle-green.svg';

export const MFACodeEmailSent: React.FC = () => {
  const { t } = useTranslation(i18nNamespaceMFAContent);

  return (
    <Typography color="grey1" variant={TypographyVariant.Paragraph2}>
      <Grid container justifyContent="center">
        <Grid item>{t('Email sent')}</Grid>

        <Grid item>
          <Box display="inline-block" ml={1}>
            <IconCheckmarkCircleGreen />
          </Box>
        </Grid>
      </Grid>
    </Typography>
  );
};
